import React, { Component } from "react";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/core/styles";
import { getSiteOrigin } from "../../helpers/siteUrl";

const styles = theme => ({
    root: {        
        position: "relative",        
        paddingBottom: "56.25%" /* 16:9 */,        
        height: 0,                
        
    },
    video: {
          position: "absolute",
          paddingRight: 1,          
          width: "100%",
          height: "100%",
          boxShadow: "rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px",
          
    }
  });

class Youtube extends Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const { youtubeId, classes } = this.props;
        const siteOrigin = getSiteOrigin();
        
        return (
            <div className={classes.root}>
                <iframe className={classes.video} title="Jerelia youtube video"
                    src={`https://www.youtube.com/embed/${youtubeId}?controls=1&fs=1&modestbranding=1&rel=0&enablejsapi=1&origin=${encodeURIComponent(siteOrigin)}&widget_referrer=${encodeURIComponent(siteOrigin)}`}
                    frameBorder="0"
                />
            </div>
        );
    }
}


export default  withWidth()(withStyles(styles, { withTheme: true })(Youtube));
// export default Youtube;
